export const config = {
  version: 2,
  cookieName: 'cpm_nebenanstiftung',
  lang: 'de',
  default: false,
  acceptAll: true,
  hideDeclineAll: true,
  translations: {
    de: {
      privacyPolicyUrl: '/privacy',
      privacyPolicy: {
        name: 'Datenschutzerklärung',
        text: 'Um mehr zu erfahren, lies bitte unsere {privacyPolicy}.',
      },
      consentModal: {
        title: 'Cookie-Einstellungen',
        description: 'Diese Seite verwendet Cookies. Dazu zählen notwendige Cookies (z.B. für eine sichere Anmeldung) sowie Cookies zur Erhebung statistischer Daten die uns helfen, diese Webseite weiter zu verbessern. Hier kannst Du die einzelnen Services individuell auswählen.',
      },
      consentNotice: {
        changeDescription: 'Wir haben unsere Cookies geändert. Bitte erneuere Deine Wahl.',
        description: 'Diese Seite verwendet Cookies. Dazu zählen notwendige Cookies (z.B. für eine sichere Anmeldung) sowie Cookies zur Erhebung statistischer Daten die uns helfen, diese Webseite weiter zu verbessern. Klicke auf „Alle auswählen", um allen Cookies zuzustimmen.',
        learnMore: 'Cookie-Einstellungen',
      },
      ok: 'Alle auswählen',
      purposes: {
        necessary: {
          title: 'Notwendige Cookies',
        },
        analytics: {
          title: 'Besucher-Statistiken',
        },
      },
    },
  },
  services: [
    {
      name: 'core',
      title: 'nebenan stiftung',
      default: true,
      required: true,
      purposes: ['necessary'],
      translations: {
        de: {
          description: 'Technische Cookies sind für das reibungslose Funktionieren der Website notwendig.',
        },
      },
    },
    {
      name: 'gtm',
      title: 'Google Analytics & Pardot',
      default: false,
      purposes: ['analytics'],
      translations: {
        de: {
          description: 'Hiermit werden Besucher-Statistiken mit Google Analytics und Pardot erfasst.',
        },
      },
      cookies: [
        [/^_ga.*$/i, '/', '.nebenan-stiftung.de'],
      ],
    },
  ],
}
